import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName } from "../../../components/Converter";
import Degree from "../../../components/Math/Units/Metric/Degree";
import { RowBody } from "../../../components/RowValue/RowBody";
import { decimalSeparator, thousandSeparator } from "../../../i18n";
import {
  selectPfahlneigungZurVertikalen,
  setPfahlneigungZurVertikalen,
} from "../../../store/slices/aeussereSlice";

export function PfahlneigungZurVertikalen({}) {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const pfahlneigungZurVertikalen = useSelector(selectPfahlneigungZurVertikalen);

  return (
    <RowBody
      titleValue={<p>{t("aeussre.pileInclinationVertical")}</p>}
      indicesValue={<span>&beta;</span>}
      inputValue={
        <NumberFormat
          className={getClassName(pfahlneigungZurVertikalen)}
          value={pfahlneigungZurVertikalen}
          decimalSeparator={decimalSeparator()}
          thousandSeparator={thousandSeparator()}
          displayType="input"
          type="text"
          onValueChange={(value) => dispatch(setPfahlneigungZurVertikalen(value.floatValue))}
          allowNegative={true}
        />
      }
      unitValue={<Degree />}
    />
  );
}
